import React from "react";

const Bike = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20.469"
    height="30"
    viewBox="0 0 21 15"
  >
    <path
      id="Bike"
      d="M871.138,64.5a4.216,4.216,0,0,0-.761.068l-1.32-3.617v-1.99h.705a.654.654,0,1,0,0-1.308h-2.73a.654.654,0,1,0,0,1.308h.717V60.4h-5.539V58.315a.66.66,0,0,0-.659-.66h-2.741a.654.654,0,0,0,0,1.308H860.9v1.99l-1.319,3.617a4.357,4.357,0,0,0-.773-.068,4.079,4.079,0,1,0,2,.523l.819-2.24L864.36,68.8l.023.045a.606.606,0,0,0,.341.33.184.184,0,0,0,.1.034.326.326,0,0,0,.148.023h2.138a4.075,4.075,0,1,0,4.026-4.731Zm-9.552,4.083a2.769,2.769,0,1,1-2.775-2.775,2.8,2.8,0,0,1,.318.023l-.921,2.525a.653.653,0,1,0,1.229.443l.92-2.536A2.813,2.813,0,0,1,861.586,68.584Zm8.017-2.32.6,1.66h-1.762A2.815,2.815,0,0,1,869.6,66.264ZM862.576,61.7h4.811L864.975,67Zm4.537,6.22h-1.126l2.342-5.152.819,2.24A4.067,4.067,0,0,0,867.113,67.924Zm4.026,3.423a2.769,2.769,0,0,1-2.695-2.115h2.695a.471.471,0,0,0,.182-.035h.011a.11.11,0,0,0,.057-.023.514.514,0,0,0,.3-.261.6.6,0,0,0,.1-.341.578.578,0,0,0-.034-.193c0-.023-.011-.034-.011-.057l-.91-2.5a2.772,2.772,0,1,1,.307,5.527Z"
      transform="translate(-854.74 -57.655)"
    />
  </svg>
);

export default Bike;
